import { makeStyles } from '@fluentui/react-components';

export const useOverviewPageStyles = makeStyles({
  pageContainer: {
    maxWidth: '1600px',
    minWidth: '200px',
  },
});
